import React, { FC } from 'react';


const EmptyComponent: FC<{}> = (): JSX.Element => <></>;


export default EmptyComponent;